import { useEffect } from 'react';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

/**
 * Hook to lock/unlock scroll, handling both standard body overflow
 * and GSAP ScrollSmoother if active.
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (isLocked) {
      // Standard scroll lock
      document.body.style.overflow = 'hidden';

      // GSAP ScrollSmoother lock
      const smoother = ScrollSmoother.get();
      if (smoother) {
        smoother.paused(true);
      }
    } else {
      // Standard scroll unlock
      document.body.style.overflow = '';

      // GSAP ScrollSmoother unlock
      const smoother = ScrollSmoother.get();
      if (smoother) {
        smoother.paused(false);
      }
    }

    return () => {
      // Cleanup on unmount
      document.body.style.overflow = '';
      const smoother = ScrollSmoother.get();
      if (smoother) {
        smoother.paused(false);
      }
    };
  }, [isLocked]);
};
